import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { EditorState } from "lexical";

import { getConfig } from "../helpers";
import { HTMLPlugin } from "../plugins/HTMLPlugin";
import { MentionsPlugin } from "../plugins/MentionsPlugin";
import { SetInitialStatePlugin } from "../plugins/SetInitialStatePlugin";
import { ToolbarPlugin } from "../plugins/ToolbarPlugin";

import { EditorContainer, InnerEditor, MuiContentEditable, PlaceHolder } from "./editorContainers";

function customOnChange({
  editorState,
  renderPropOnChange,
}: {
  editorState: EditorState;
  renderPropOnChange?: (newValue: string) => void;
}) {
  editorState.read(() => {
    if (renderPropOnChange) {
      const editorStateJSON = editorState.toJSON();
      const stringifiedValue = JSON.stringify(editorStateJSON);
      renderPropOnChange(stringifiedValue);
    }
  });
}

export function EditLexical({
  initialState,
  renderPropOnChange,
  setValue,
  mentionEndpoint,
  includeHtml,
  placeholder = "Enter some text...",
}: {
  initialState: string;
  renderPropOnChange?: (newValue: string) => void;
  setValue?: (key: string, mentioned_account_ids: number[] | string) => void;
  mentionEndpoint?: string;
  includeHtml?: boolean;
  placeholder?: string;
}) {
  return (
    <LexicalComposer initialConfig={{ ...getConfig() }}>
      <EditorContainer>
        <ToolbarPlugin />
        <InnerEditor>
          <RichTextPlugin
            contentEditable={
              <MuiContentEditable
                aria-placeholder={placeholder}
                placeholder={<PlaceHolder>{placeholder}</PlaceHolder>}
              />
            }
            ErrorBoundary={LexicalErrorBoundary}
          />
          <SetInitialStatePlugin initialState={initialState} />
          {renderPropOnChange && (
            <OnChangePlugin onChange={(editorState) => customOnChange({ editorState, renderPropOnChange })} />
          )}
          {mentionEndpoint && setValue && <MentionsPlugin mentionEndpoint={mentionEndpoint} setValue={setValue} />}
          {includeHtml && setValue && <HTMLPlugin setValue={setValue} />}
          <HistoryPlugin />
        </InnerEditor>
      </EditorContainer>
    </LexicalComposer>
  );
}
